import { forwardRef, useState } from 'react'
import { Button, Icon } from '../../UI'

interface InputFileProps {
  className?: string,
  type?: 'button',
  id?: string,
  name: string,
  accept?: string,
  butonText?: string,
  tabIndex?: number,
  multiple?: boolean,
  onChange(name: string, value: any): void,
  onError?(type: 'ERROR' | 'CLEAR', name?: any, value?: any): void
}

type Ref = HTMLInputElement;

const InputFileMultiple = forwardRef<Ref, InputFileProps>(({ className = '', type = 'button', id, name, accept = 'image/x-png,image/jpeg,application/pdf', butonText = '', tabIndex, multiple = false, onChange, onError }, ref) => {
  const [filesTags, setFilesTags] = useState<FileList | undefined>(undefined)
  const [inputKey, setInputKey] = useState(Math.random().toString(36));
  const [filterValue, setFilterValue] = useState('');

  const CFilesTags = () => {
    let fileTagsHtml: any[] = []
    if (filesTags === undefined) return null;
    const filteredFiles = Array.from(filesTags).filter((file: File) =>
        file.name?.toLowerCase().includes(filterValue?.toLowerCase())
    );

    for (let i: number = 0; i < filteredFiles.length; i++) {
      const file = filteredFiles[i]
      fileTagsHtml.push(
          <div key={i} className={`d-flex justify-content-between input-file-tag w-full`}>
            {file.name}
            <div className='pull-right'>
              <Icon name="file-delete" onClick={() => onFilesTagsDel(i)} /> 
            </div>
          </div>
      )
    }
    return (
        <>
          {fileTagsHtml}
        </>
    );
  }

  const onBtnFileClick = (name: string) => {
    const inputFile = document.getElementById(name)

    if(inputFile) inputFile.click()
  }

  const onFileChange = (event: any) => {
    const { target: { name, files } } = event

    if(files && files[0]) {
      const fieldName: string = name
      const fileType = files[0].type
      const fileSize = files[0].size

      if(fileType && (fileType.indexOf('png') === -1 && fileType.indexOf('jpeg') === -1 && fileType.indexOf('pdf') === -1)) {
        if(onError) onError(
            'ERROR',
            fieldName,
            {
              type: 'format',
              message: 'Selecciona formato png, jpg o pdf'
            }
        )
        return ;
      } else if(fileSize && (fileSize / 1024 > 20000)) {
        if(onError) onError(
            'ERROR',
            fieldName,
            {
              type: 'size',
              message: 'Selecciona tamaño máximo 20MB'
            }
        )
        return ;
      }

      const filesArray = Array.from(files) as File[];
      const updatedFiles = filesTags ? [...Array.from(filesTags), ...filesArray] : [...filesArray];
      const dataTransfer = new DataTransfer();
      updatedFiles.forEach((file: File) => dataTransfer.items.add(file as File));
      setFilesTags(dataTransfer.files);
      onChange(fieldName, dataTransfer.files)
      if(onError) onError('CLEAR')
      setInputKey(Math.random().toString(36));
    }
  }

  const onFilesTagsDel = (index: number) => {
    if (!filesTags) return;
    const filesArray = Array.from(filesTags);
    filesArray.splice(index, 1);
    const dataTransfer = new DataTransfer();
    filesArray.forEach(file => dataTransfer.items.add(file));
    setFilesTags(dataTransfer.files);
    onChange(name, dataTransfer.files);
  }

  return (

     <>
    <div className="d-flex">
       {<input
           type="text"
           className="input w-full file-fitler mt-10"
           placeholder="Buscar archivo"
           value={filterValue}
           onChange={(e) => setFilterValue(e.target.value)}
       /> }
       <div className={`input-file ${className}`}>
         <Button
             size="md"
             borderRadius="4px"
             fullWidth
             className='mt-10 file-upload-btn'
             tabIndex={tabIndex}
             onClick={() => onBtnFileClick(name)}
         >{butonText}</Button>

         <input
             key={inputKey}
             ref={ref}
             type="file"
             id={id}
             name={name}
             accept={accept}
             multiple={multiple}
             onChange={onFileChange} />
       </div>
    </div>
    <div className="w-full">
    {filesTags && filesTags.length > 0 &&
        <div className="mt-10 w-full">
            <CFilesTags />
        </div>
    }
    </div>
     </>

  )
})

export { InputFileMultiple }